import { render, staticRenderFns } from "./SelectedProductList.vue?vue&type=template&id=44d491e9&scoped=true&"
import script from "./SelectedProductList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SelectedProductList.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SelectedProductList.vue?vue&type=style&index=0&id=44d491e9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d491e9",
  null
  
)

export default component.exports